import { Injectable} from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http'
import { Subject, Observable, ReplaySubject } from 'rxjs/Rx'
import { SweetAlertService } from './sweetalert.service'
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute} from '@angular/router'
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
// import { AdminRole } from './adminrole.enum'
// import * as firebase from 'firebase';
declare var firebase:any

export enum AdminRole {
  SuperAdmin,
  BrandAdmin,
  StoreAdmin,
  StoreStaff
}

export interface POSUser {
    uid:string,
    email:string,
    displayName:string,
    phone:string,
    role:string,
    disabled:boolean,
    lastSignedInAt:string,
    brands:Map<string,boolean>,
    stores:Map<string,boolean>
}

@Injectable()
export class UsersService {

  currentUser: POSUser
  subject = new ReplaySubject<boolean>(1)

  constructor(private http: Http, public sa:SweetAlertService, private router: Router) {
    firebase.initializeApp(environment.firebaseConfig)

      //firebase.firestore.setLogLevel('debug')
    firebase.auth().onAuthStateChanged(
      user => {
        // console.log("auth changed: ", user);

        //  this.signOut()
        if (user) {
          if (this.currentUser == null) {

            firebase.firestore().collection("posUsers").doc(user.uid).get().then(
              doc => {
                this.currentUser = doc.data() as POSUser
                this.currentUser.uid = user.uid
                if (this.currentUser.role == AdminRole[AdminRole.StoreStaff]) {
                    this.sa.showError('權限不足，無法登入')
                    this.signOut()
                    this.router.navigate(['/sigin'])
                    return
                }
                this.checkIfBrandEnabled()
              }
            ).catch(
              err => {
                alert(err.toString())
              }
            )
          } else {
            this.subject.next(true)
            // this.checkIfBrandEnabled()
          }

        } else {
          this.subject.next(false)
        }
      }
    )
  }


  isAuthenticated(): Observable<boolean> {

    return this.subject.asObservable()
  }

  checkIfBrandEnabled() {
    if (this.currentUser.role == AdminRole[AdminRole.SuperAdmin]) {
        this.subject.next(true)
        return
    }
    let brandId = Object.keys(this.currentUser.brands)[0]

    firebase.firestore().collection("brands").doc(brandId).get().then(
      b => {
        if (b.data().enabled) {
          if (this.currentUser.role == AdminRole[AdminRole.BrandAdmin]) {
              this.subject.next(true)
              return
          }else {
            this.checkIfStoreEnabled()
          }
        }else {
          this.sa.showError('您所屬的品牌已停用，請聯絡服務專員。')
          this.signOut()
          this.router.navigate(['/sigin'])

        }
      }
    )
  }

  checkIfStoreEnabled() {
    let storeId = Object.keys(this.currentUser.stores)[0]

    firebase.firestore().collection("stores").doc(storeId).get().then(
      s => {
        if (s.data().enabled) {
          this.subject.next(true)
        }else {
          this.sa.showError('您所屬的店家已停用，請聯絡服務專員。')
          this.signOut()
          this.router.navigate(['/sigin'])
        }
      }
    )
  }

  isSuperAdmin():boolean {
    return this.currentUser.role == AdminRole[AdminRole.SuperAdmin]
  }

  signInUser(email: string, password: string) {
      return firebase.auth().signInWithEmailAndPassword(email, password)
  }

  sendResetEmail(email:string) {
    return firebase.auth().sendPasswordResetEmail(email)
  }

  siteverify(token:string) {
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let options = new RequestOptions({ headers: headers })

    let params = `response=${token}&secret=6LfAuSEUAAAAADzLlMxO_CbXbw7qmfj5tqADT0hY`

    return this.http.post('https://www.google.com/recaptcha/api/siteverify',params,options)
    // return this.http.post('https://us-central1-beanadmindev.cloudfunctions.net/recaptcha', params, options)
  }

  signOut() {
    firebase.auth().signOut()
    this.currentUser = null
  }

  reauthenticate(pwd:string) {
    let user = firebase.auth().currentUser;
    let credential = firebase.auth.EmailAuthProvider.credential(user.email, pwd)

    return user.reauthenticateWithCredential(credential)
  }

  updateUserProfile(profile: any) {
    return firebase.firestore().collection('posUsers').doc(this.currentUser.uid).update(profile)

  }

  updateUserPwd(pwd: string) {
    return firebase.auth().currentUser.updatePassword(pwd)
  }

  createBrandAdmin(email: string, password: string, displayName: string, brandId: string) {
    // let param = {email:email,password:password,displayName:displayName}
    return Observable.fromPromise(firebase.auth().currentUser.getIdToken(true)).mergeMap(
      (token) => {
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded',
                                    'Authorization': 'Bearer ' + token })
        let options = new RequestOptions({ headers: headers })

        let params = `email=${email}&password=${password}&displayName=${displayName}&brandId=${brandId}`


        return this.http.post(environment.cloudFunctionURL+'createBrandAdmin', params, options)
      }
    )


  }

  getBrandAdmins(brandId: string) {
    return Observable.fromPromise(firebase.auth().currentUser.getIdToken(true)).mergeMap(
      (token) => {
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded',
                                    'Authorization': 'Bearer ' + token})
        let options = new RequestOptions({ headers: headers })

        let params = `brandId=${brandId}`


        return this.http.post(environment.cloudFunctionURL+'getBrandAdmins', params, options)
                .map(res => res.json())
                .catch((err:Response) => {
                  let details = err.json();
                  return Observable.throw(details);
                });
              })

  }

  createStoreStaff(email: string, password: string, displayName: string, role:string,phone:string,phoneCountryCode:string,
     brandId: string, storeId:string) {
    // let param = {email:email,password:password,displayName:displayName}
    return Observable.fromPromise(firebase.auth().currentUser.getIdToken(true)).mergeMap(
      (token) => {
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded',
                                    'Authorization': 'Bearer ' + token })
        let options = new RequestOptions({ headers: headers })

        let params = `email=${email}&password=${password}&displayName=${displayName}&brandId=${brandId}&storeId=${storeId}&phone=${phone}&phoneCountryCode=${phoneCountryCode}&role=${role}`

        return this.http.post(environment.cloudFunctionURL+'createStoreStaff', params, options)
      })

  }

  updateStoreStaff(info:any) {
    return Observable.fromPromise(firebase.auth().currentUser.getIdToken(true)).mergeMap(
      (token) => {
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded',
                                    'Authorization': 'Bearer ' + token })
        let options = new RequestOptions({ headers: headers })
        let params = `uid=${info.uid}&phone=${info.phone}&phoneCountryCode=${info.phoneCountryCode}&displayName=${info.displayName}&role=${info.role}`
        if (info.password) {
            params+=`&password=${info.password}`
        }
        console.log(params)
        return this.http.post(environment.cloudFunctionURL+'updateStoreStaff', params, options)
      })

  }

  updateStaffStores(staff:POSUser) {
    console.log(staff)
    return firebase.firestore().collection('posUsers').doc(staff.uid).update({stores:staff.stores})
  }

  getStoreStaff(storeId: string) {
    return Observable.fromPromise(firebase.auth().currentUser.getIdToken(true)).mergeMap(
      (token) => {
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded',
                                    'Authorization': 'Bearer ' + token })
        let options = new RequestOptions({ headers: headers })

        let params = `storeId=${storeId}`

        return this.http.post(environment.cloudFunctionURL+'getStoreStaff', params, options)
                .map(res => res.json())
                .toPromise()
                .catch((err:Response) => {
                  let details = err.json();
                  return Observable.throw(details);
                });
              })

  }

  queryBrandStaff(param:any,brandId:string) {
    let q = firebase.firestore().collection('posUsers').where('brands.'+brandId,"==",true)
    if (param.displayName) {
        q = q.where('displayName',"==",param.displayName)
    }

    if (param.email) {
      q = q.where('email',"==",param.email)
    }

    if (param.phone) {
      q = q.where('phone',"==",param.phone)
    }

    if (param.role) {
      q = q.where('role',"==",param.role)
    }
    return q.get()

  }

  togglePOSUserStatus(disabled:boolean,uid:string) {
    return Observable.fromPromise(firebase.auth().currentUser.getIdToken(true)).mergeMap(
      (token) => {
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded',
                                    'Authorization': 'Bearer ' + token })
        let options = new RequestOptions({ headers: headers })

        let params = `uid=${uid}&disabled=${disabled}`

        return this.http.post(environment.cloudFunctionURL+'togglePOSUserStatus', params, options)
              .map(res => res.json())
              .catch((err:Response) => {
                let details = err.json();
                return Observable.throw(JSON.stringify(details));
              });
            })
  }

  deletePOSUser(uid:string) {
    return Observable.fromPromise(firebase.auth().currentUser.getIdToken(true)).mergeMap(
      (token) => {
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded',
                                    'Authorization': 'Bearer ' + token })
        let options = new RequestOptions({ headers: headers })

        let params = `uid=${uid}`

        return this.http.post(environment.cloudFunctionURL+'deletePOSUser', params, options)
              .map(res => res.json())
              .catch((err:Response) => {
                // alert(err.toString())

                let details = err.json();
                return Observable.throw(JSON.stringify(details));
              });
            })
  }

}



// WEBPACK FOOTER //
// ./src/app/services/users.service.ts